import { useTranslation } from "react-i18next";
import {
  Flex
} from "antd";
import { ChangeEvent, FunctionComponent, KeyboardEvent } from "react";

import {
  SearchOutlined
} from "@ant-design/icons";
import FormInput from "../../../../components/form-input/FormInput";
import "./filter-table.scss";

type FilterTableProps = {
  handleOpen?: () => void;
  searchValue: string;
  handleChangeInput: (e: ChangeEvent<HTMLInputElement>) => void;
  handleSearch: (e: KeyboardEvent<HTMLSpanElement>) => void;
  handleSubmitSearch: () => void;

};

const FilterTable: FunctionComponent<FilterTableProps> = ({
  handleChangeInput,
  searchValue,
  handleSearch,
  handleSubmitSearch,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Flex>
        <div className="">
          <FormInput
            placeholder={t("Nhập tên sinh viên cần tìm", "Nhập tên sinh viên cần tìm")}
            value={searchValue}
            onChange={handleChangeInput}
            onKeyPress={handleSearch}
            afterPrefixIcon={<SearchOutlined onClick={handleSubmitSearch} />}
          />
        </div>
      </Flex>
    </>
  );
};

export default FilterTable;